export default "__VITE_ASSET__C3lt8P3e__";